const images = {
  common: {
    kitchen_login: require('assets/images/kitchen_login.png'),
    cashier_sidebar: require('assets/images/cashier_sidebar.png'),
    avatar_default: require('assets/images/avatar_default.jpg'),
  },
  illustrations: {
    kitchen_login: require('assets/illustrations/illustration_store.svg').default,
    mbkc_cook: require('assets/illustrations/mbkc_cook.svg').default,
    no_permission: require('assets/illustrations/illustration_403.svg').default,
    not_found: require('assets/illustrations/illustration_404.svg').default,
    server_error: require('assets/illustrations/illustration_500.svg').default,
    empty_content: require('assets/illustrations/illustration_empty_content.svg').default,
    otp: require('assets/illustrations/illustration_otp.svg').default,
    email: require('assets/illustrations/illustration_email.svg').default,
  },
  logo: {
    logo_mbkc: require('assets/logos/logo_mbkc.png'),
    logo_mbkc_no_bg: require('assets/logos/logo_mbkc_no_background.png'),
    logo_mbkc_text: require('assets/logos/text_mbkc_1.png'),
  },
  language: {
    english: require('assets/icons/ic_flag_en.svg').default,
    vietnamese: require('assets/icons/ic_flag_vn.svg').default,
  },
};

export default images;
